import { Ref } from 'react'

type Variant = 'default' | 'success' | 'emphasis' | 'caution' | 'warning' | 'magic' | 'critical' | 'brand'
type Placement = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'

type Props = {
    reduceMotion?: boolean
    variant?: Variant
    placement?: Placement
    smallOffset?: boolean
    className?: string
    ref?: Ref<HTMLDivElement>
    'data-test'?: string
}

const filledColorStyles: Record<Variant, string> = {
    default: 'bg-brand-strong-rest ',
    success: 'bg-success-strong-rest ',
    emphasis: 'bg-brand-strong-rest ',
    caution: 'bg-caution-strong-rest ',
    warning: 'bg-caution-strong-rest ',
    magic: 'bg-magic-strong-rest ',
    critical: 'bg-critical-strong-rest ',
    brand: 'bg-brand-strong-rest',
}

const placementStyles: Record<Placement, string> = {
    'top-right': 'right-[-.25rem] top-[-.25rem]',
    'top-left': 'left-[-.25rem] top-[-.25rem]',
    'bottom-right': 'right-[-.25rem] bottom-[-.25rem]',
    'bottom-left': 'left-[-.25rem] bottom-[-.25rem]',
}

const smallOffsetPlacementStyles: Record<Placement, string> = {
    'top-right': 'right-[-.125rem] top-[-.125rem]',
    'top-left': 'left-[-.125rem] top-[-.125rem]',
    'bottom-right': 'right-[-.125rem] bottom-[-.125rem]',
    'bottom-left': 'left-[-.125rem] bottom-[-.125rem]',
}

/**
 * Tiny Indicator is a small dot pinned to a corner of its parent to signal that something there is new
 * or needs attention, without saying what. Place it inside a `relative` parent. Use Badge when the state needs
 * a label or count.
 *
 * @summary for a corner dot signalling something new or needing attention
 */
export const AstraTinyIndicator = ({
    ref,
    reduceMotion = false,
    variant = 'default',
    placement = 'top-right',
    smallOffset,
    className = '',
    'data-test': dataTest,
}: Props) => (
    <div
        ref={ref}
        className={`absolute flex size-2 items-center justify-center rounded-full text-[.5rem] shadow-sm ${!reduceMotion ? 'animate-pulse' : ''} ${filledColorStyles[variant]} ${smallOffset ? smallOffsetPlacementStyles[placement] : placementStyles[placement]} ${className}`}
        data-test={dataTest}
    />
)
